<template>
  <div>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div class="report-crm" :class="{ 'blur--content': isLoading }">
      <h1 class="text-center">Retention Product</h1>
      <div class="d-flex">
        <div class="row">
          <div class="col-4">
            <label for="brandSelected" required>Brand</label>
            <multiselect
              id="brandSelected"
              v-model="brandSelected"
              :options="brands"
              label="text"
              track-by="id"
              placeholder="เลือก Brands"
            >
            </multiselect>
            <div v-if="isSubmit && !brandSelected" class="text-error">
              กรุณาเลือก Brand
            </div>
          </div>
          <div class="col-4">
            <label for="yearSelected" required>Year</label>
            <multiselect
              id="yearSelected"
              v-model="yearSelected"
              :options="years"
              :allow-empty="false"
              deselect-label=""
              placeholder="เลือก ปี"
            >
            </multiselect>
          </div>
          <div class="col-4">
            <label for="monthSelected" required>Month</label>
            <multiselect
              id="monthSelected"
              v-model="monthSelected"
              :options="months"
              label="text"
              track-by="id"
              :allow-empty="false"
              deselect-label=""
              placeholder="เลือก เดือน"
            >
            </multiselect>
          </div>
        </div>
        <div class="row text-right">
          <div class="col align-self-center">
            <button
              class="btn btn-outline-primary"
              style="width: 100%; max-width: 131px"
              @click="getProcessId"
            >
              OK
            </button>
          </div>
        </div>
      </div>

      <div v-if="listData.length > 0" class="table-crm mt-3">
        <div class="export-to-excel">
          <button
            class="btn btn-outline-dark"
            @click="exportExcel"
            :disabled="listData.length === 0"
          >
            Export to excel
          </button>
        </div>
        <div class="text-description pt-5">
          สินค้าที่ลูกค้าซื้อซ้ำ 2 ปีติดกัน โดยดูจากการซื้อเดือนที่ 1-12 และ
          13-24 ย้อนหลังจากเดือนที่เลือก และจัดลำดับตาม Product Name
          เนื่องจากบาง Product Name มีหลาย Product Code
        </div>
        <div class="row pt-5">
          <div class="d-flex align-items-center justify-content-start col">
            <span class="mr-2">Show</span>
            <b-form-select
              class="form-control w-auto"
              v-model="perPage"
              :options="pageOptions"
            ></b-form-select>
            <span class="ml-2">entries</span>
          </div>
          <div class="d-flex align-items-center justify-content-end col">
            <label for="filterItem" class="mx-3">Search: </label>
            <input
              id="filterItem"
              type="text"
              v-model="filterItem"
              class="form-control w-50"
            />
          </div>
        </div>
        <b-table
          id="retention-table"
          class="table table-bordered w-100 report-table"
          hover
          responsive
          :items="listData"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filterItem"
          @filtered="onFiltered"
          no-footer-sorting
        >
          <template #cell(noOfCustomers)="data">
            <div class="text-right">
              {{ data.item.noOfCustomers.toLocaleString() }}
            </div>
          </template>
          <template #cell(quantity)="data">
            <div class="text-right">
              {{ data.item.quantity.toLocaleString() }}
            </div>
          </template>
          <template #cell(amount)="data">
            <div class="text-right">
              {{ data.item.amount.toLocaleString() }}
            </div>
          </template>
          <template #cell(percentContributionCustomer)="data">
            <div class="text-right">
              {{ percentageFormat(data.item.percentContributionCustomer) }}
            </div>
          </template>
          <template #cell(percentContributionQuantity)="data">
            <div class="text-right">
              {{ percentageFormat(data.item.percentContributionQuantity) }}
            </div>
          </template>
          <template #cell(percentContributionAmount)="data">
            <div class="text-right">
              {{ percentageFormat(data.item.percentContributionAmount) }}
            </div>
          </template>
          <template slot="bottom-row">
            <td class="text-center" colspan="2">Total</td>
            <td class="text-right">
              {{ total.noOfCustomers.toLocaleString() }}
            </td>
            <td class="text-right">
              {{ total.quantity.toLocaleString() }}
            </td>
            <td class="text-right">
              {{ total.amount.toLocaleString() }}
            </td>
            <td class="text-right">
              {{ percentageFormat(total.percentContributionCustomer) }}
            </td>
            <td class="text-right">
              {{ percentageFormat(total.percentContributionQuantity) }}
            </td>
            <td class="text-right">
              {{ percentageFormat(total.percentContributionAmount) }}
            </td>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="retention-table"
        ></b-pagination>
      </div>
      <div class="pt-15" v-else-if="message">
        <h1 class="text-center">{{ message }}</h1>
      </div>
    </div>
    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h5 class="p-5 failureMessage">{{ failureMessage }}</h5>
        <div class="text-center">
          <button class="btn-back" @click="showDialog = false">ปิด</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import ExcelJS from "exceljs";
import downloadExcel from "./downloadExcel.js";
import fields from "@/json/reports/fields_retention.json";
import BrandService from "services/api/brand.service";
import ReportService from "@/services/api/report.service";
export default {
  data() {
    return {
      brands: [],
      brandSelected: null,
      yearSelected: moment().format("YYYY"),
      years: [],
      monthSelected: null,
      months: [],
      fileName: `retention_product_${moment().format("YYYYMMDDHHmmss")}`,
      listData: [],
      fields: fields,
      isLoading: false,
      isSubmit: false,
      message: null,
      failureMessage: null,
      showDialog: false,
      total: {},
      processId: null,
      getRetentionListInterval: null,
      currentPage: 1,
      perPage: 30,
      pageOptions: [
        5,
        10,
        20,
        30,
        40,
        50,
        {
          value: Number.MAX_SAFE_INTEGER,
          text: "show all",
        },
      ],
      totalRows: 1,
      filterItem: "",
    };
  },
  mounted() {
    this.getBrands();
    this.setYears();
    this.setMonths();
  },
  methods: {
    async getBrands() {
      await BrandService.getListBrands()
        .then((res) => {
          const data = res.data;
          this.brands = data.brand.map((s) => {
            return {
              id: s.code,
              text: s.name,
            };
          });
          if (data.brand.length === 1) {
            this.bindingData(data.brand[0]);
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
        });
    },
    bindingData(val) {
      this.brandSelected = {
        id: val.code,
        text: val.name,
      };
    },
    percentageFormat(value) {
      if (value) {
        return downloadExcel.percentageFormat(value);
      } else {
        return "";
      }
    },
    async getProcessId() {
      this.isSubmit = true;
      this.listData = [];
      this.message = null;
      if (!this.brandSelected || !this.yearSelected || !this.monthSelected) {
        return;
      }
      this.isLoading = true;
      const param = {
        brand: this.brandSelected?.id,
        year: this.yearSelected,
        month: this.monthSelected.id,
      };
      await ReportService.getRetentionProductProcessId(param)
        .then((res) => {
          const data = res.data;
          this.processId = data.processId;
          this.getRetentionListInterval = setInterval(() => {
            this.getList();
          }, 10000);
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err);
        });
    },

    async getList() {
      const param = {
        process: this.processId,
      };
      await ReportService.getRetentionProduct(param)
        .then((res) => {
          const data = res.data;
          if (data.processStatus.toUpperCase() === "EXECUTED") {
            this.clearTimeInterval();
            this.isLoading = false;
            this.listData = data.products;
            this.total = data.total;
            this.totalRows = this.listData.length;
            if (data.products.length <= 0) {
              this.message = data.message;
            }
          }
        })
        .catch((err) => {
          console.log("Error: ", err);
          const errRes = err.response;
          if (errRes.status !== 400) {
            this.isLoading = false;
            this.clearTimeInterval();
            this.failureMessage =
              errRes.data?.message ||
              "An error occurred, please try again later!";
            this.showDialog = true;
          }
        });
    },
    clearTimeInterval() {
      clearInterval(this.getRetentionListInterval);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    exportExcel() {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Sheet 1");
      sheet.columns = sheet.columns = this.fields.map((f) => {
        return {
          key: f.key,
          header: f.header,
        };
      });
      this.listData.forEach((item) => {
        sheet.addRow({
          rank: item.rank,
          productName: item.productName,
          noOfCustomers: item.noOfCustomers,
          quantity: item.quantity,
          amount: item.amount,
          percentContributionCustomer: item.percentContributionCustomer,
          percentContributionQuantity: item.percentContributionQuantity,
          percentContributionAmount: item.percentContributionAmount,
        });
      });

      const rowsInsert = [
        {
          productName: "Total",
          noOfCustomers: this.total.noOfCustomers,
          quantity: this.total.quantity,
          amount: this.total.amount,
          percentContributionCustomer: this.total.percentContributionCustomer,
          percentContributionQuantity: this.total.percentContributionQuantity,
          percentContributionAmount: this.total.percentContributionAmount,
        },
      ];

      sheet.insertRows(this.listData.length + 2, rowsInsert);

      //get column
      const rankCol = sheet.getColumn("rank");
      const productNameCol = sheet.getColumn("productName");
      const noOfCustomerComma = sheet.getColumn("noOfCustomers");
      const quantityComma = sheet.getColumn("quantity");
      const amountComma = sheet.getColumn("amount");
      const customerPercent = sheet.getColumn("percentContributionCustomer");
      const quantityPercent = sheet.getColumn("percentContributionQuantity");
      const amountPercent = sheet.getColumn("percentContributionAmount");

      //set thousand separator
      noOfCustomerComma.numFmt = "#,###";
      quantityComma.numFmt = "#,###";
      amountComma.numFmt = "#,###";

      //set percentage
      customerPercent.numFmt = "0.00%";
      quantityPercent.numFmt = "0.00%";
      amountPercent.numFmt = "0.00%";

      //set width
      productNameCol.width = 35;
      noOfCustomerComma.width = 15;
      quantityComma.width = 15;
      amountComma.width = 20;
      noOfCustomerComma.width = 15;
      noOfCustomerComma.width = 15;

      //set center
      rankCol.alignment = { vertical: "middle", horizontal: "center" };

      workbook.xlsx
        .writeBuffer()
        .then((res) => {
          downloadExcel.downloadFile(res, this.fileName);
        })
        .catch((ex) => console.log("Error: ", ex));
    },
    setMonths() {
      moment.months().map((m, index) => {
        this.months.push({
          id: index + 1,
          text: m,
        });
      });
      this.monthSelected = this.months.find(
        (s) => s.text === moment().format("MMMM")
      );
    },
    setYears() {
      const currYear = Math.floor(Number.parseInt(moment().format("YYYY")));
      for (let i = currYear; 1950 <= i; i--) {
        this.years.push(i.toString());
      }
    },
  },
};
</script>

<style lang="scss" scoped>
label[required]::after {
  content: "*";
  color: red;
  margin-left: 5px;
}
.export-to-excel {
  padding-top: 1rem;
  display: flex;
  justify-content: flex-end;
}
.export-btn {
  display: inline-block;
  font-weight: 400;
  line-height: 1.5;
  border: 1px solid #212529;
  background-color: transparent;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
}
.report-table {
  ::v-deep thead {
    tr {
      th {
        vertical-align: middle;
      }
    }
  }
}
.export-btn:hover {
  color: #fff;
  background-color: #212529;
  border-color: #212529;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.blur--content {
  filter: blur(2px);
  pointer-events: none;
}
</style>
